import { init as joinMeeting } from './meeting/join'
import { init as registerWebinar } from './webinar/register'
import { init as joinWebinar } from './webinar/join'

jQuery(() => {

  const { TangibleLive } = window 
  
  const init = () => {
    joinMeeting()
    joinWebinar()
    registerWebinar()
  }

  TangibleLive.shortcodes = {
    init: init
  }
  
  init()
})
